import React, { useState, useEffect } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput
} from 'react-admin';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const CmsBlockCreate = () => {

    return (
        <Create>
            <SimpleForm>
                <TextInput name="name" source="name" />
                <TextInput name="identifier" source="identifier" />
                <BooleanInput name="enabled" source="enabled" />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
